import type { IntegrationType, IntegrationProvider } from '@yawi/types';

export interface IntegrationWizardData {
  type: IntegrationType;
  provider: IntegrationProvider;
  name: string;
  priority: number;
  config: Record<string, string | number | boolean>;
}

export const initialWizardData: IntegrationWizardData = {
  type: 'EMAIL',
  provider: 'SENDGRID',
  name: '',
  priority: 0,
  config: {},
};

export interface StepProps {
  data: IntegrationWizardData;
  onChange: (data: Partial<IntegrationWizardData>) => void;
  onValidChange: (isValid: boolean) => void;
}
